export const faqItems = [
  {
    q: '成人学历教育获得的学历国家承认吗？',
    a: '成人学历教育（包括成人高考、自学考试、网络教育和国家开放大学）均属于国民教育系列，是国家承认的正规学历。毕业生信息在学信网（中国高等教育学生信息网）终身可查，学历证书可用于考研、考公务员、评职称、出国留学、求职就业等。',
  },
  {
    q: '四种学历提升方式有什么区别，该如何选择？',
    a: '成人高考适合希望在固定学制内系统学习、有一定学习基础的学员；自学考试适合自律性强、追求高含金量学历的学员；网络教育适合工作繁忙、需要灵活学习时间的在职人士；国家开放大学适合希望免试入学、稳妥毕业的学员。建议根据自身的学习基础、时间安排和职业规划来选择。',
  },
  {
    q: '在职期间学习，时间上能安排得过来吗？',
    a: '完全可以。这四种学历提升方式都充分考虑了在职人士的特点，学习时间灵活。网络教育和国家开放大学以在线学习为主，可以利用碎片时间学习；成人高考函授形式每学期只需参加几次集中面授；自学考试完全自主安排学习进度。只要合理规划时间，每天坚持1-2小时学习，完全可以在不影响工作的情况下完成学业。',
  },
  {
    q: '学历提升的学费大概需要多少？',
    a: '费用因学习方式和院校不同而有所差异。自学考试费用最低，主要支出为考试报名费和教材费，全部下来约2000-5000元。成人高考学费通常在5000-8000元/年。网络教育学费约6000-10000元/年。国家开放大学学费约3000-5000元/年。具体以各院校当年公布的标准为准。',
  },
  {
    q: '没有高中毕业证可以报考吗？',
    a: '自学考试对此没有限制，任何人均可报考。成人高考报考高起专/高起本原则上需要高中（或同等学力）毕业证。网络教育和国家开放大学报考专科层次一般也需要高中或同等学力证明。如果没有高中毕业证，建议选择自学考试，或者先通过成人中专等方式获得高中同等学力后再报考其他方式。',
  },
  {
    q: '学历提升后可以考研吗？',
    a: '可以。通过成人学历教育获得的本科学历（需在学信网可查），可以报考全国硕士研究生统一招生考试。需要注意的是，部分高校和专业对同等学力考生有额外要求（如发表论文、加试科目等），具体以报考院校的招生简章为准。',
  },
  {
    q: '报名后多久可以拿到毕业证书？',
    a: '自学考试没有固定学制，最快专科1.5-2年、本科2-3年可完成全部课程；成人高考学制一般为高起专和专升本2.5-3年、高起本5年；网络教育学制一般为2.5-5年；国家开放大学最短学习年限为2.5年。需要注意的是，学制是从正式入学（而非报名）开始计算的。',
  },
  {
    q: '如果考试没通过怎么办？',
    a: '自学考试每门课程考试不通过可以无限次补考，直到通过为止。成人高考如果入学考试未通过，需要等到下一年重新报考。网络教育和国家开放大学的课程考试一般都有补考机会，补考未通过也有重修机会。整体来说，只要认真学习，通过率都在较高水平。',
  },
  {
    q: '成人学历和普通全日制学历有什么区别？',
    a: '两者在学习形式上不同：普通全日制是全天在校学习，成人学历是业余学习。但在法律效力上，两者都是国家承认的国民教育系列学历。成人学历证书上会注明学习形式（如"函授""业余""网络教育"等），而全日制学历证书无此标注。在考研、考公务员、评职称等方面，两者具有同等报考资格。',
  },
  {
    q: '如何选择靠谱的学历提升机构？',
    a: '选择学历提升机构时请注意以下几点：1) 查看机构是否具备教育部门颁发的办学许可证；2) 了解合作院校是否为教育部备案的正规高校；3) 咨询在读学员的真实评价；4) 避免"包过""快速拿证"等虚假承诺；5) 确认收费项目和标准是否透明。我们的平台汇集了多所正规高校的官方授权，提供高清视频课程和名师辅导，值得信赖。',
  },
];